// Copyright 2025, University of Maryland, All Rights Reserved
import { Card, CardHeader, CardTitle } from "@/components/ui/card"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { Database } from "lucide-react"
import type { DataSource } from '@/hooks/admin/useDatasourceState'

interface DataSourceSelectorProps {
  selectedDataSource: DataSource
  onDataSourceChange: (dataSource: DataSource) => void
  dataSources: readonly DataSource[]
}

export function DataSourceSelector({ 
  selectedDataSource, 
  onDataSourceChange, 
  dataSources 
}: DataSourceSelectorProps) {
  const getDataSourceIcon = (dataSource: DataSource) => {
    return dataSource === 'Maryland' ? '🏛️' : '🇺🇸'
  }

  return (
    <Card className="border shadow-sm">
      <CardHeader className="pb-2">
        <div className="flex items-center gap-3">
          <CardTitle className="text-lg flex items-center gap-2">
            <Database className="h-4 w-4" />
            Data Source:
          </CardTitle>
          <Select
            value={selectedDataSource}
            onValueChange={onDataSourceChange}
          >
            <SelectTrigger className="w-[160px] h-8">
              <SelectValue>
                <div className="flex items-center gap-1">
                  <span>{getDataSourceIcon(selectedDataSource)}</span>
                  {selectedDataSource}
                </div>
              </SelectValue>
            </SelectTrigger>
            <SelectContent>
              {dataSources.map((source) => (
                <SelectItem key={source} value={source}>
                  <div className="flex items-center gap-1">
                    <span>{getDataSourceIcon(source)}</span>
                    {source}
                  </div>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </CardHeader>
    </Card>
  )
}
